import {
    FaBriefcase,
    FaCloud,
    FaHeadset,
    FaMicrosoft,
    FaBook,
    FaLanguage,
    FaStickyNote,
    FaGift,
  } from "react-icons/fa";
  import { useState } from "react";
  
  const offerings = [
    { title: "Hardware networking with cloud computing", icon: FaBriefcase, top: "#c7d2fe", bottom: "#818cf8" },
    { title: "Cloud Computing", icon: FaCloud, top: "#fdba74", bottom: "#f97316" },
    { title: "Data analyst", icon: FaHeadset, top: "#fdba74", bottom: "#f97316" },
    { title: "ITIL V4", icon: FaMicrosoft, top: "#c7d2fe", bottom: "#818cf8" },
    { title: "Devops", icon: FaBook, top: "#c7d2fe", bottom: "#818cf8" },
    { title: "Internship", icon: FaLanguage, top: "#fdba74", bottom: "#f97316" },
    { title: "Microsoft Certification Course", icon: FaStickyNote, top: "#fdba74", bottom: "#f97316" },
    { title: "Doubt session and 24 support", icon: FaGift, top: "#c7d2fe", bottom: "#818cf8" },
  ];
  
  const OfferingsSection = () => {
    const [activeIndex, setActiveIndex] = useState(null);
  
    return (
      <section className="px-6 md:px-20 py-16 bg-white">
        <div className="max-w-7xl mx-auto">
  
          <h2 className="text-5xl font-bold text-center text-gray-800">
            Best offerings for you
          </h2>
          <p className="text-center text-gray-400 text-xl mt-1">
            Get ready for your exam with best content and latest test series
          </p>
  
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-12">
            {offerings.map((item, index) => {
              const Icon = item.icon;
              const isActive = activeIndex === index;
  
              return (
                <div
                key={index}
                className="rounded-xl overflow-hidden shadow-lg hover:scale-105 transition w-[300px] h-[200px]"
              >
                <div
                  className="relative p-4 flex justify-between items-start h-[130px]"
                  style={{ backgroundColor: item.top }}
                >
                  <h4 className="text-xl font-bold text-gray-900 max-w-[65%] leading-tight text-start">
                    {item.title}
                  </h4>
            
                  <Icon className="text-4xl text-gray-800 mt-7" />
            
                  <svg
                    viewBox="0 0 380 100"
                    className="absolute bottom-[-1px] left-0 w-full h-[45px]"
                    preserveAspectRatio="none"
                  >
                    <path
                      d="M0,50 C120,90 240,10 360,30 480,50 600,20 720,25 840,30 960,70 1080,50 1200,30 1320,10 1440,20 L1440,100 L0,100 Z"
                      fill={item.bottom}
                    />
                  </svg>
                </div>
              
                <div
                  className="px-4 py-3 flex items-center h-[70px]"
                  style={{ backgroundColor: item.bottom }}
                >
<button
  onClick={() => setActiveIndex(isActive ? null : index)}
  className={`
    relative flex items-center gap-3 px-4 py-2 text-sm font-semibold
    rounded-full overflow-hidden
    transition-all duration-300
    ${
      isActive
        ? "bg-white text-gray-900 shadow-md"
        : "bg-black/20 text-white hover:shadow-lg"
    }
  `}
>
  <span
    className={`
      absolute top-0 left-0 h-full w-0 bg-white transition-all duration-300
      ${isActive ? "w-full" : "group-hover:w-full"}
    `}
  />

  <span className="relative z-10">Explore</span>

  <span
    className={`
      relative z-10 w-2.5 h-2.5 rounded-full transition-all
      ${isActive ? "bg-green-500 scale-125" : "bg-white"}
    `}
  />
</button>



                </div>
              </div>
              
              );
            })}
          </div>
  
        </div>
      </section>
    );
  };
  
  export default OfferingsSection;
  